import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Seguimiento/addSeguimiento`, method: 'POST', body: values, token: token})
}
